module.exports = __webpack_public_path__ + "static/media/grafico-unicred-centro-sul-5.c4dd43d8.png";